export default "__VITE_ASSET__ccb3c13d__"